// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import VUEX from 'vuex'

import Vuetify from 'vuetify'
// import * as VueGoogleMaps from 'vue2-google-maps'
// import { Vue2Dragula } from 'vue2-dragula'
// import VueQuillEditor from 'vue-quill-editor'
// import wysiwyg from 'vue-wysiwyg'
// import VueBreadcrumbs from 'vue2-breadcrumbs'
// import VueResource from 'vue-resource'
import VmBackTop from 'vue-multiple-back-top'
import notification from 'vue-notification'
// import AmCharts from 'amcharts3'
// import AmSerial from 'amcharts3/amcharts/serial'
// import AmAngularGauge from 'amcharts3/amcharts/gauge'
import Lang from 'vuejs-localization'
import App from './App'
import router from './router'

import store from "./store"

// jvector map
// import 'jvectormap'
// import 'jvectormap/tests/assets/jquery-jvectormap-world-mill-en'
// import 'jvectormap/jquery-jvectormap.css'

// import './assets/css/googlefonts.source.sans.pro.css'
// import './assets/css/material.icons.css'

// import 'font-awesome/css/font-awesome.min.css' // Ensure you are using css-loader


// include all css files
import './lib/VuelyCss'
import './permission' // permission control

// import VueLazyload from 'vue-lazyload'
// Vue.use(VueLazyload, {
//   error: '/static/img/none.png',
//   loading: '/static/img/loading.gif',
//   try: 1 // default 1
// })

Vue.use(VUEX)
Vue.use(Vuetify,{
	iconfont: 'fa4'
})
// Vue.use(AmCharts)
// Vue.use(AmSerial)
// Vue.use(AmAngularGauge)
// Vue.use(Vue2Dragula)
// Vue.use(VueQuillEditor)
// Vue.use(VueResource)
// Vue.use(wysiwyg, {})
// Vue.use(VueBreadcrumbs)
Vue.use(notification)
Vue.component(VmBackTop.name, VmBackTop)

Lang.requireAll(require.context('./lang', true, /\.js$/))
Vue.use(Lang)

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App,notification }
})



// WEBPACK FOOTER //
// ./src/main.js